<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">用户系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>KYC基础配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="item">
        <span>
          1.未认证每日累计提现金额 ≤
          <span class="info" v-if="!withdrawInfo.noKycWithdrawalBTCMaxStatus">无限制</span>
          <span class="info" v-else>{{ withdrawInfo.noKycWithdrawalBTCMax }}</span>BTC
        </span>
        <el-button type="primary" plain @click="edit('nokyc')">编辑</el-button>
      </div>
      <div class="item">
        <span>
          2.完成基础身份认证每日累计提现金额 ≤
          <span class="info" v-if="!withdrawInfo.baseKycWithdrawalBTCMaxStatus">无限制</span>
          <span class="info" v-else>{{ withdrawInfo.baseKycWithdrawalBTCMax }}</span>BTC
        </span>
        <el-button type="primary" plain @click="edit('basekyc')">编辑</el-button>
      </div>
      <div class="item">
        <span>
          3.完成高级实名认证每日累计提现金额
          <span class="info" v-if="!withdrawInfo.highKycWithdrawalBTCMaxStatus">无限制</span>
          <span class="info" v-else>{{ withdrawInfo.highKycWithdrawalBTCMax }}</span>BTC
        </span>
        <el-button type="primary" plain @click="edit('highkyc')">编辑</el-button>
      </div>
      <div class="item">
        <span>
          4.每人每天最多提交
          <span class="info" v-if="!noKycInfo.status">无限制</span>
          <span class="info" v-else>{{ noKycInfo.num }}</span>次实名审核
        </span>
        <el-button type="primary" plain @click="edit('realname')">编辑</el-button>
      </div>
    </el-card>
    <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="350px">
      <div class="editbox" v-if="isRealname">
        <div class="item">
            <span>是否限制提现次数</span>
            <el-switch style="display: block" v-model="noKyc.status"></el-switch>
          </div>
        <div class="item">
          <span>每人每天提交审核限制次数</span>
        </div>
        <div class="item">
          <el-input :disable="!noKyc.status" placeholder="请填写每人每天提交审核限制次数" v-model="noKyc.num">
            <i slot="suffix">次</i>
          </el-input>
        </div>
      </div>
      <div class="editbox" v-else>
        <div class="item">
          <span>实名认证阶段</span>
          <span v-if="editInfo === 'nokyc'">未认证</span>
          <span v-if="editInfo === 'basekyc'">基础身份认证</span>
          <span v-if="editInfo === 'highkyc'">高级实名认证</span>
        </div>
        <div v-if="editInfo === 'nokyc'">
          <div class="item">
            <span>是否限额</span>
            <el-switch style="display: block" v-model="withdraw.noKycWithdrawalBTCMaxStatus"></el-switch>
          </div>
          <div class="item">
            <span>未认证每日提现限制金额</span>
          </div>
          <div class="item">
            <el-input placeholder="请填写未认证每日提现限制金额" v-model="withdraw.noKycWithdrawalBTCMax">
              <i slot="suffix">BTC</i>
            </el-input>
          </div>
        </div>
        <div v-if="editInfo === 'basekyc'">
          <div class="item">
            <span>是否限额</span>
            <el-switch style="display: block" v-model="withdraw.baseKycWithdrawalBTCMaxStatus"></el-switch>
          </div>
          <div class="item">
            <span>基础身份认证每日累计提现金额</span>
          </div>
          <div class="item">
            <el-input placeholder="请填写基础身份认证每日累计提现金额" v-model="withdraw.baseKycWithdrawalBTCMax">
              <i slot="suffix">BTC</i>
            </el-input>
          </div>
        </div>
        <div v-if="editInfo === 'highkyc'">
          <div class="item">
            <span>是否限额</span>
            <el-switch style="display: block" v-model="withdraw.highKycWithdrawalBTCMaxStatus"></el-switch>
          </div>
          <div class="item">
            <span>高级实名认证每日累计提现金额</span>
          </div>
          <div class="item">
            <el-input placeholder="请填写高级实名认证每日累计提现金额" v-model="withdraw.highKycWithdrawalBTCMax">
              <i slot="suffix">BTC</i>
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="isSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
      quotaStatus: false,
      dialogFormVisible: false,
      isRealname: false,
      noKyc: {
        num: "",
        status: false
      },
      withdraw: {
        noKycWithdrawalBTCMaxStatus: false,
        baseKycWithdrawalBTCMaxStatus: false,
        highKycWithdrawalBTCMaxStatus: false,
        noKycWithdrawalBTCMax: "",
        baseKycWithdrawalBTCMax: "",
        highKycWithdrawalBTCMax: ""
      },
      withdrawInfo: {},
      noKycInfo: {},
      editInfo: ""
    };
  },
  methods: {
    getApplyNum() {
      api.getAuthApply().then(res => {
        const data = JSON.parse(res.data);
        this.noKycInfo = data;
      });
    },
    getWithdrawal() {
      api.getKycWithdrawal().then(res => {
        const data = JSON.parse(res.data);
        this.withdrawInfo = data
      });
    },
    edit(type) {
      this.withdraw = JSON.parse(JSON.stringify(this.withdrawInfo))
      this.noKyc = JSON.parse(JSON.stringify(this.noKycInfo))
      switch (type) {
        case "nokyc":
          this.editInfo = "nokyc";
          this.dialogFormVisible = true;
          this.isRealname = false;
          break;
        case "basekyc":
          this.editInfo = "basekyc";
          this.dialogFormVisible = true;
          this.isRealname = false;
          break;
        case "highkyc":
          this.editInfo = "highkyc";
          this.dialogFormVisible = true;
          this.isRealname = false;
          break;
        case "realname":
          this.editInfo = "realname";
          this.dialogFormVisible = true;
          this.isRealname = true;
          break;
      }
    },
    isSubmit() {
      switch (this.editInfo) {
        case "nokyc":
          this.dialogFormVisible = false;
          let noKycData = this.withdraw
          // let noKycData = {
          //   noKycWithdrawalBTCMaxStatus: this.withdraw.noKycWithdrawalBTCMaxStatus,
          //   noKycWithdrawalBTCMax: this.withdraw.noKycWithdrawalBTCMax
          // }
          this.updateWithdraw(JSON.stringify(noKycData))
          break;
        case "basekyc":
          this.dialogFormVisible = false;
          let baseData = this.withdraw
          // let baseData = {
          //   baseKycWithdrawalBTCMaxStatus: this.withdraw.baseKycWithdrawalBTCMaxStatus,
          //   baseKycWithdrawalBTCMax: this.withdraw.baseKycWithdrawalBTCMax
          // }
          this.updateWithdraw(JSON.stringify(baseData))
          break;
        case "highkyc":
          this.dialogFormVisible = false;
          let highData = this.withdraw
          // let highData = {
          //   highKycWithdrawalBTCMaxStatus: this.withdraw.highKycWithdrawalBTCMaxStatus,
          //   highKycWithdrawalBTCMax: this.withdraw.highKycWithdrawalBTCMax
          // }
          this.updateWithdraw(JSON.stringify(highData))
          break;
        case "realname":
          this.dialogFormVisible = false;
          this.isRealname = false;
          let numData = {
            status: this.noKyc.status,
            num: this.noKyc.num
          }
          this.updateApplyNum(JSON.stringify(numData))
          break;
      }
    },
    updateWithdraw(data) {
      api.updateKycWithdrawal({key: data}).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getWithdrawal();
      })
    },
    updateApplyNum(data) {
      api.updateApplyNum({key: data}).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getApplyNum();
      })
    },
    onClose() {
      this.dialogFormVisible = false;
    }
  },
  created() {
    this.getApplyNum();
    this.getWithdrawal();
  }
};
</script>
<style lang="less" scoped>
.item {
  margin-bottom: 10px;
  display: flex;
  justify-content: start;
  line-height: 40px;
  span {
    display: inline-block;
    margin-right: 10px;
    &.info {
      padding: 0 10px;
      color: red;
    }
  }
}
.editbox {
  .item {
    display: flex;
    justify-content: space-between;
  }
}
</style>